import WmtsLayer from './wmtsLayer.js'
import WmsLayer from './wmsLayer.js'
import WmstLayer from './wmstLayer.js'

export default class Layer {
  static fromSource (source) {
    switch (source.serviceType) {
      case WmtsLayer.serviceType:
        return new WmtsLayer(source)
      case WmsLayer.serviceType:
        return new WmsLayer(source)
      case WmstLayer.serviceType:
        return new WmstLayer(source)
      default:
        throw new Error(`${source.serviceType} is not supported yet.`)
    }
  }

  static get userLayersName () {
    return 'userLayers'
  }

  static get backgroundLayersName () {
    return 'backgroundLayers'
  }

  static getLayerCollectionByName (mapRef, name) {
    return mapRef.getLayers().getArray()[0].getLayers().getArray().find((l) => l.name === name)
  }

  static getUserLayers (mapRef) {
    return Layer.getLayerCollectionByName(mapRef, Layer.userLayersName)
  }

  static getBackgoundLayers (mapRef) {
    return Layer.getLayerCollectionByName(mapRef, Layer.backgroundLayersName)
  }
}
